import classNames from "classnames";

export interface EmptyOptionProps {
  className?: string;
  label?: string;
}

export const EmptyOption = ({ label = "", className }: EmptyOptionProps) => (
  <div
    className={classNames(
      "text-light relative cursor-default select-none px-5 py-2 text-sm",
      className,
    )}
  >
    {label}
  </div>
);
